import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button,IconButton, Typography } from "@mui/material";

import { CloseIcon, PenMenuIcon } from "../../Icons";
import {
  setAdminDialogParams,
  showAdminDialog,
} from "../../store/reducers/dialogSlice";
import { closeDrawer } from "../../store/reducers/drawerSlice";
import { resetSelectedRow } from "../../store/reducers/tableSlice";

export const RightAdminDrawer = () => {
  const dispatch = useDispatch();

  const { isShown } = useSelector((state: any) => state.drawer);
  const { selectedRow: rowData } = useSelector((state: any) => state.table);

  const handleClose = () => {
    dispatch(resetSelectedRow());
    dispatch(closeDrawer());
  };

  const getBasicEditParams = () => {
    return {
      step: 0,
      maxAvailableStep: 1,
      isEdit: true,
      data: rowData,
    };
  };

  const handleEditAllButton = () => {
    handleClose();
    setTimeout(() => {
      dispatch(setAdminDialogParams(getBasicEditParams()));
      dispatch(showAdminDialog());
    }, 100);
  };

  const handleEditBasicInfoButton = () => {
    handleClose();
    dispatch(setAdminDialogParams(getBasicEditParams()));
    dispatch(showAdminDialog());
  };

  const handleEditAssignButton = () => {
    handleClose();
    dispatch(
      setAdminDialogParams({
        ...getBasicEditParams(),
        step: 1,
      })
    );
    dispatch(showAdminDialog());
  };

  return (
    <Box
      sx={{
        top:82,
        position: "fixed",
        width: "424px",
        height: "calc(100vh - 82px)",
        zIndex: 1000,
        backgroundColor: "#F3F3F3",
        right: "0px",
        display: isShown ? "block" : "none",
        transition: "right 0.3s",
        boxShadow: isShown
          ? "rgba(0, 0, 0, 0.1) -3px 10px 15px 0px"
          : undefined,
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          height: "62px",
          backgroundColor: "white",
          padding: "10px 16px",
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{
            width: "32px",
            height: "32px",
            borderRadius: "6px",
            backgroundColor: "#F3F3F3",
            color: "#676767",
            fontSize: "20px",
          }}
          disableRipple
        >
          <CloseIcon fontSize="inherit" />
        </IconButton>

        <Box sx={{ flex: 1, textAlign: 'center' }}>
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "600",
            }}
          >
            About admin {rowData.status === "deleted" && "(Deleted)"}
          </Typography>
        </Box>

        {rowData.status !== "deleted" &&
          <Button
            sx={{
              fontSize: "14px",
              fontWeight: "400",
            }}
            onClick={handleEditAllButton}
            disableRipple
          >
            Edit all
          </Button>
        }
      </Box>

      <Box
        display="flex"
        sx={{
          padding: "16px 16px",
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          sx={{
            backgroundColor: "white",
            flex: 1,
            borderRadius: "6px",
            padding: "16px 16px 24px",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 10px 0px",
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              flex: 1,
              marginBottom: "24px",
            }}
          >
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Basic information
            </Typography>

            {rowData.status !== "deleted" &&
              <IconButton
                onClick={handleEditBasicInfoButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            }
          </Box>

          <Box
            display="flex"
            alignItems="center"
            sx={{
              flex: 1,
              marginBottom: "16px",
            }}
          >
            <img
              src={rowData.photo}
              style={{
                width: "104px",
                height: "104px",
                borderRadius: "12px",
                marginRight: "16px",
              }}
            />

            <Box
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              sx={{
                height: "100%",
              }}
            >
              <Box>
                <Typography
                  sx={{
                    fontSize: "12px",
                    textTransform: "uppercase",
                    color: "#828282",
                  }}
                >
                  id
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#080808",
                  }}
                >
                  {rowData.id}
                </Typography>
              </Box>
              <Box>
                <Typography
                  sx={{
                    textTransform: "uppercase",
                    fontSize: "12px",
                    color: "#828282",
                  }}
                >
                  Name
                </Typography>
                <Typography
                  sx={{
                    fontSize: "14px",
                    color: "#080808",
                  }}
                >{`${rowData.firstName} ${rowData.lastName}`}</Typography>
              </Box>
            </Box>
          </Box>
          <Box>
            <Typography
              sx={{
                textTransform: "uppercase",
                fontSize: "12px",
                color: "#828282",
              }}
            >
              Email
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                color: "#080808",
              }}
            >
              {rowData.email}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        display="flex"
        sx={{
          padding: "0 16px",
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          sx={{
            backgroundColor: "white",
            flex: 1,
            borderRadius: "6px",
            padding: "16px 16px 24px",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 10px 0px",
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              flex: 1,
              marginBottom: "24px",
            }}
          >
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Assign
            </Typography>

            {rowData.status !== "deleted" &&
              <IconButton
                onClick={handleEditAssignButton}
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#BF295C",
                  fontSize: "16px",
                }}
                disableRipple
              >
                <PenMenuIcon fontSize="inherit" />
              </IconButton>
            }
          </Box>
          <Box>
            <Typography
              sx={{
                textTransform: "uppercase",
                fontSize: "12px",
                color: "#828282",
              }}
            >
              Studio
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                color: "#080808",
              }}
            >
              {rowData.studios?.length === 0
                ? "Without studio"
                : `${rowData.studios?.map((el: any) => el.title).join("; ")}.`}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
